import type { Filter } from '../../../../../stores/filters';

export type FilterPrefix = keyof EngagementDefaultFilters;

interface EngagementDefaultFilters {
  site: Record<string, Filter>;
  search: Record<string, Filter>;
  email: Record<string, Filter>;
  social: Record<string, Filter>;
  media: Record<string, Filter>;
}

export const defaultEngagementFilters: EngagementDefaultFilters = {
  site: {
    site_events_filter: {
      filterName: 'site_events_filter',
      expression: 'Yes',
      enabled: true,
      expressionType: 'target',
    },
  },
  search: {
    search_events_filter: {
      filterName: 'search_events_filter',
      expression: 'Yes',
      enabled: true,
      expressionType: 'target',
    },
  },
  email: {
    email_action_filter: {
      filterName: 'email_action_filter',
      expression: 'Opened an Email',
      enabled: true,
      expressionType: 'target',
    },
    email_events_filter: {
      filterName: 'email_events_filter',
      expression: 'Yes',
      enabled: true,
      expressionType: 'target',
    },
  },
  social: {
    social_events_filter: {
      filterName: 'social_events_filter',
      expression: 'Yes',
      enabled: true,
      expressionType: 'target',
    },
  },
  media: {
    media_action_filter: {
      filterName: 'media_action_filter',
      expression: 'Exposed to Media',
      enabled: true,
      expressionType: 'target',
    },
    media_events_filter: {
      filterName: 'media_events_filter',
      expression: 'Yes',
      enabled: true,
      expressionType: 'target',
    },
  },
};
